
import React from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import LeftNavigation from 'Components/Navigation/LeftNavigation/LeftNavigation.js';
//import { PUBLIC_SIDE_NAV_ITEMS } from 'Components/Navigation/LeftNavigation/LeftNavigationData.js';
import MatchRoutes from 'Components/MatchRoutes/MatchRoutes.js';
import Popup from "Components/Popup/Popup";
import { STATUSES, ERROR_MESSAGES, DEFAULT_STATE_VALUE, WindowState, TOKEN_AUTH_VALIDATION_INTERVAL } from "Utils/constants";
import { useState, useEffect, useRef, useCallback } from "react";
import { store } from 'Store';
import { useDispatch, useSelector } from "react-redux"
import { setStatus, setPopup, setRedirect } from "./Store/ErrorInfoSlice";
import BackToTop from 'Components/BackToTop/BackToTop';
import Breadcrumbs from 'Components/Breadcrumbs/Breadcrumbs.js';
import { setLastValidity, setToken } from 'Store/LoginInfoSlice';
//import "Styles/scss/previous/app.scss" ;
import PageVisibility from 'react-page-visibility';
import Header3 from 'Components/Header/Header3';
import { httpLogin } from 'Utils/httpLogin';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import PublicFooter from 'Components/Public/Footer/PublicFooter';
import { PATHS } from 'Utils/PagePaths';
import { isPublicPage } from 'Utils/utilityFunctions';
import { Row } from 'react-bootstrap';
import { getPathCrumbs } from 'Components/Breadcrumbs/BreadcrumbsData';
import PublicLeftNavigation from 'Components/Navigation/LeftNavigation/PublicLeftNavigation';

import { ga_log_content_group, ga_log_sign_in, ga_log_sign_out } from 'Utils/GA4/GTM';
import SyncTabs, { Counter } from 'Components/TestSync/Counter';
import Testbroadcast from 'Components/TestSync/Testbroadcast';
    
    

function App () {

    
    


    var gtmData = null;
  const [styleVersion, setStyleVersion] = useState("current");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showCollapsedSideNav, setShowCollapsedSideNav] = useState(false);
  const resetStateValue = {
    status: STATUSES.NORMAL,
    popup: {
      visible: false,
      title: "",
      msg: "",
      showContactHelp: false
    },
    redirect: {
      redirect: false,
      redirectFirst: false,
      path: "",
      data: {}
    },
    error: null
  };

  const location = useLocation();
  const [changePage, setChangePage] = useState(false);

  const handleStorageChange = (e) => {
    //console.log("CHANGE STORAGE", e, e.key);

    /*if(e.storageArea != localStorage){
        return;
    }
    else{
        
    }*/

    if (e.key == "persist:root" && e.oldValue !== e.newValue) {
      //console.log("reload");
      setChangePage(true);
      //window.location.reload();
    }

  }
  //window.addEventListener('storage', handleStorageChange);


  //console.log("store state", store.getState().loginInfo);
  const state = store.getState().errorInfo;
  const styleState = store.getState().styleInfo;

  //console.log(state);
  const [globalStatus, setGlobalStatus] = useState(state.status);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMsg, setPopMsg] = useState({ title: state.popup.title, msg: state.popup.msg, showContactHelp: state.popup.showContactHelp })
  const [styleLoading, setStyleLoading] = useState(true);
  //const [styleVersion, setStyleVersion] = useState(styleState.version);
  const [isDomReady, setIsDomReady] = useState(false);

    useEffect(()=>{
       
       
       
    
    },[])

   
    
  const handlePopup = (flag) => {
    setShowPopup(flag);
  }

  const [visible, setVisible] = useState(true);

  let cartList = useSelector((state) => state.errorInfo);
  let loginState = useSelector((state) => state.loginInfo);
  const token = "Bearer " + loginState.token;
  const dispatch = useDispatch();

  const topRef = useRef(null);

  useEffect(() => {

    // const state = store.getState();
    //console.log("get state.status?.code");
    //console.log("state.status?.code", state.status?.code);
    if (state.status?.code == STATUSES.SESSION_TIMEOUT.code) {
      //console.log("TIMEOUT", state);
      if (pathname && isPublicPage(location) == true) {//pathname.includes("publicpages")) {
        navigate(
          pathname,
          { state: state }
        )
      } else {
        navigate(
          PATHS.public['Sign In'],
          { state: state }
        )
      }
      setGlobalStatus(state.status);
      setShowPopup(state.popup.visible);
      setPopMsg({ title: state.popup.title, msg: state.popup.msg, showContactHelp: state.popup.showContactHelp });
    }
    else {
      //console.log("STATE", state);

      setGlobalStatus(state.status);
      setShowPopup(state.popup.visible);
      setPopMsg({ title: state.popup.title, msg: state.popup.msg, showContactHelp: state.popup.showContactHelp });


      if (state.redirect.redirect == true && state.redirect.redirectFirst == true) {
        navigate(
          state.redirect.path,
          { state: state.redirect.data }
        );

        //if(pathname == state.redirect.path){

        //}


      }
      else {
        setGlobalStatus(state.status);
        setShowPopup(state.popup.visible);
        setPopMsg({ title: state.popup.title, msg: state.popup.msg, showContactHelp: state.popup.showContactHelp });
      }
    }





    //dispatch(setStatus(STATUSES.NORMAL))
  }, [cartList])



  const handleClose = (e) => {
    //console.log(e);
    dispatch(setStatus(STATUSES.NORMAL));
    dispatch(setPopup({ visible: false, title: "", msg: "", showContactHelp: false }));

    //console.log("handleClose state", state);

    setGlobalStatus(state.status);
    setShowPopup(state.popup.visible);
    setPopMsg({ title: state.popup.title, msg: state.popup.msg, showContactHelp: state.popup.showContactHelp });

    if (state.redirect.redirect == true) {
      navigate(
        state.redirect.path,
        { state: state.redirect.data }
      );
    }
    dispatch(setRedirect({ redirect: false, redirectFirst: false, path: "", data: {} }));
  };


  const [pageHeight, setPageHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);


  /*const pageRef = useCallback((node) => {
    if (!node) {
        return;
    }
    const resizeObserver = new ResizeObserver((entry) => { 
        //console.log(entry[0]);
        setPageHeight(entry[0].target.clientHeight);
        //console.log(entry[0].target.clientHeight);
        //console.log("resizePage");
    });
    resizeObserver.observe(node);
  }, [setPageHeight]);*/

  const footerRef = useRef(0);
  const pageRef = useRef(0);

  const [breadcrumbPath, setBreadcrumbs] = useState([]);
  const [updated, setUpdated] = useState(loginState);

  const [signedIn, setSignedIn] = useState(false);

  const handleNavChange = (e) => {
    //console.log(e);
    setSignedIn(!signedIn);
  }

  // useEffect(() => {
  //   //console.log("UPDATESTATE", loginState);
  //   setUpdated(loginState);
  // }, [loginState])


  store.subscribe((s) => {
    //console.log("store.subscribe");
  })

  const handleVisibilityChange = isVisible => {
    if (changePage == true) {
      setVisible(isVisible);
      //console.log("VISIBLE", isVisible);
    }
  }
  const handleCloseClick = (e) => {
    setVisible(false);
    setChangePage(false);
    window.location.reload();
  }

  // api to validate token
  const validateAccess = async (token) => {

    const url = "/api/validation";

    const res = await httpLogin.post(url, {}, {
      headers: {
        "Authorization": token
      }
    })

    return res;
  }


  useEffect(() => {

    let validateAccessInterval = null;

    const intervalFunc = () => {
      if (store.getState().loginInfo?.token) {
        let tokenAuth = "Bearer " + store.getState().loginInfo.token;
        // refresh token if a new token is generated
        if (localStorage.getItem("token")) {
          //console.log("get new token", localStorage.getItem("token"));
          tokenAuth = "Bearer " + localStorage.getItem("token");
          dispatch(setToken(localStorage.getItem("token")));
          // remove the temp token storage
          localStorage.removeItem("token");
        }
        //let tokenAuth = "Bearer " + store.getState().loginInfo.token;
        let lastValidity = store.getState().loginInfo.lastValidity;
        // Reduce the number of the api calls when multiple tabs are open
        if (lastValidity == null || Math.floor((Date.now() - lastValidity) / 1000) >= TOKEN_AUTH_VALIDATION_INTERVAL) {
          dispatch(setLastValidity(Date.now()));
          validateAccess(tokenAuth)
            .then((res) => {
              //dispatch(setLastValidity(Date.now()));
            }).catch((error) => {
              setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: ERROR_MESSAGES.DATA_ERROR.title,
                  msg: ERROR_MESSAGES.DATA_ERROR.message,
                  showContactHelp: true
                },
                redirect: {
                  redirect: false,
                  redirectFirst: false,
                  path: "",
                  data: {}
                },
                error: error
              });
              if (error.response?.status == 401) {
                window.clearInterval(validateAccessInterval);
                ga_log_sign_out();
              }
            })
        }
      }
    }

    intervalFunc();
    if (store.getState().loginInfo?.token) {
      //validateAccessInterval = setInterval(intervalFunc, 10000);
      validateAccessInterval = window.setInterval(intervalFunc, TOKEN_AUTH_VALIDATION_INTERVAL * 1000);
      sessionStorage.setItem("validateAccessInterval", validateAccessInterval);
    }
        
        // window.dataLayer = window.dataLayer || [];
        // if(store.getState().loginInfo?.token){
        //     ga_log_sign_in();
        // }
        // else{
        //     ga_log_sign_out();
        // }
    
    
  }, [store.getState().loginInfo?.token]);

  // scroll to top after the route change
  useEffect(() => {
    ga_log_content_group(location);
    
    //ga_log_page_view(location, m);
    //ga_log_page_view(location);
    //getDestinationID();
    
    
    //console.log("Path: " + pathname);
    window.scrollTo(0, 0);

    //console.log(document.readyState);
    // callback function to call when event triggers
    const onPageLoad = () => {
        //ga_log_page_view(location);
        //console.log(window.dataLayer)
    
        //console.log('page loaded');
        var d = document.getElementById("mainheader");
        //console.log(d);
        d.focus();
        
        
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
    
      onPageLoad();

    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
    
  }, [pathname]);

  const handleShowCollapsedSideNav = () => {
    setShowCollapsedSideNav(true);
  }

  const handleCloseCollapsedSideNav = () => {
    setShowCollapsedSideNav(false);
  }

  //console.log(pathname);

  const setFocus = (e) => {
    //console.log(e);
    pageRef.current.focus();
  }


  const contentRef = useRef(0);
  //console.log(contentRef);

  return (

    <PageVisibility onChange={handleVisibilityChange}>

      <div className="App d-flex flex-column" id="page-container" ref={pageRef} updated={updated} >

        { }
        {/**TODO!!!: comment below*/}
        {/**visible == true && changePage == true ? <Button onClick={handleCloseClick}>Session Expired Continue On</Button> : <p>NOT</p> */}

        
        <Popup showPopup={showPopup} handlePopup={handlePopup} handleClose={handleClose} popupMsg={popupMsg} resetStateValue={resetStateValue} variant={globalStatus.text} />
        {/**TODO!!!: comment below*/}
        {/* <Header></Header> */}
        {/* <Header2 signedIn={signedIn} setSignedIn={setSignedIn}></Header2> */}
        <Header3 showCollapsedSideNav={handleShowCollapsedSideNav} topRef={topRef}></Header3>
        {/* <Testbroadcast></Testbroadcast> */}
        {/* <SyncTabs></SyncTabs> */}
        <Breadcrumbs crumb={getPathCrumbs(location.pathname)} path={location.pathname} ></Breadcrumbs>
        {isPublicPage(location) == true ?
          <Row ref={contentRef} className="m-0 public-background">
            <MatchRoutes setBreadcrumbs={setBreadcrumbs}
              showCollapsedSideNav={showCollapsedSideNav}
              closeCollapsedSideNav={handleCloseCollapsedSideNav}
            ></MatchRoutes>
            <PublicLeftNavigation
              showCollapsedSideNav={showCollapsedSideNav}
              closeCollapsedSideNav={handleCloseCollapsedSideNav}
            ></PublicLeftNavigation>
            <BackToTop topRef={topRef}></BackToTop>
          </Row>
          :
          <LeftNavigation
            //sideNavItems={PUBLIC_SIDE_NAV_ITEMS}
            showCollapsedSideNav={showCollapsedSideNav}
            closeCollapsedSideNav={handleCloseCollapsedSideNav}
            ref={contentRef}
            pageRef={pageRef}
          >
            <MatchRoutes setBreadcrumbs={setBreadcrumbs} ></MatchRoutes>
            <BackToTop topRef={topRef}></BackToTop>
          </LeftNavigation>
        }
        {/**TODO: 10/09/2025: remove the old footer after testing the new Public Footer */}
        {/* <Footer footerRef={footerRef} footerHeight={footerHeight} setFooterHeight={setFooterHeight}></Footer> */}
        <PublicFooter pageRef={pageRef}></PublicFooter>
      </div>
    </PageVisibility>
  );
}

export default App;
